import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { QuestionnaireStep } from "../../pages/Questionnaire/schema/questionnaire";
import { questionnaireApi } from "./questionnaire.api";

const initialState: QuestionnaireStep[] = [];

export const questionnaireSlice = createSlice({
	name: "questionnaire",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			questionnaireApi.endpoints.getQuestionnaire.matchFulfilled,
			(state, { payload }) => {
				return payload ?? [];
			}
		);
		builder.addMatcher(
			questionnaireApi.endpoints.createQuestionnaireStep.matchFulfilled,
			(state, { payload }) => {
				if (payload?.id) {
					return [...state, payload];
				}
			}
		);
		builder.addMatcher(
			questionnaireApi.endpoints.updateQuestionnaireStep.matchFulfilled,
			(state, { payload }) => {
				if (payload?.id) {
					const index = state.findIndex((todo) => todo.id === payload.id);

					if (index !== -1) {
						state[index] = payload;
					}
				}

				return state;
			}
		);
		builder.addMatcher(
			questionnaireApi.endpoints.updateQuestionnaireStepNumber.matchFulfilled,
			(state, { payload }) => {
				if (payload?.length) {
					return payload;
				}
			}
		);
		builder.addMatcher(
			questionnaireApi.endpoints.deleteQuestionnaireStep.matchFulfilled,
			(state, { payload }) => {
				if (payload) {
					return payload;
				}
			}
		);
	},
});

export const {} = questionnaireSlice.actions;
export const questionnaireReducer = questionnaireSlice.reducer;
export const questionnaireSelector = (state: RootState) => state[questionnaireSlice.name];
